import React, { useState } from 'react';
import { TableContent } from 'entities/table/ui/TableContent';
import { Box, CircularProgress, Stack, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useGetStoriesQuery } from 'features/useStories';
import { StoriesFormWidget } from 'widgets/content/ui/StoriesFormWidget';
import { StoryType } from 'widgets/content/types';

const fields = [
  { field: 'id', title: 'ID', width: '5%' },
  { field: 'title', title: 'Название', width: '25%' },
  { field: 'description', title: 'Описание', width: '25%' },
  { field: 'image', title: 'Медиа', width: '25%' },
  { field: 'priority', title: 'Приоритет', width: '20%' },
];

const BrandImage = ({ src }: { src: string }) => (
  <Box
    component="img"
    sx={{ height: '50px', width: '50px', objectFit: 'cover' }}
    alt="Alt text"
    src={src}
  />
);

export const StoriesListWidget = () => {
  const navigate = useNavigate();
  const [pagination, setPagination] = useState<{ page: number; count: number }>({ page: 0, count: 10 });

  const stories = useGetStoriesQuery({ page: pagination.page + 1, size: pagination.count });

  const listTable = () => {
    if (stories.data) {
      return stories.data.items.map((item: StoryType) => ({
        id: item.id,
        title: item.contents[0]?.title || '---',
        description: item.contents[0]?.description || '---',
        priority: item.priority || '---',
        image: item.contents[0]?.image ? <BrandImage src={item.contents[0].image} /> : '---',
      }));
    }
    return [];
  };

  const handleDetail = (id: number) => {
    navigate(`/content/stories/${id}`);
  };

  if (stories.isFetching) {
    return (
      <Stack alignItems="center">
        <CircularProgress />
      </Stack>
    );
  }

  if (stories.isError) {
    return <Stack alignItems="center">ERROR</Stack>;
  }

  return stories.isSuccess ? (
    <>
      {stories.data.total > 0 ? (
        <TableContent
          title="Список сторисов"
          fields={fields}
          list={{ list: listTable() }}
          count={stories.data.total}
          page={pagination.page}
          perPage={pagination.count}
          onPageChange={(_, page) => setPagination((prev) => ({ ...prev, page }))}
          onRowsPerPageChange={(e) => {
            setPagination(() => ({
              page: 0,
              count: e.target.value as any,
            }));
          }}
          onRowClick={handleDetail}
        />
      ) : (
        <Typography align="center">В данный момент, отсутствуют данные по этой таблице</Typography>
      )}

      <StoriesFormWidget
        refetch={stories.refetch}
        detail={{}}
      />
    </>
  ) : null;
};
